<template>
  <div class="text-center">
    <v-dialog v-model="dialog" width="500" persistent>
      <v-card>
        <v-card-title class="text-center pb-0"> Descargar Excel de las Recaudaciones </v-card-title>

        <v-card-text>
          <v-divider></v-divider>
          <p class="mt-0 text-center green darken-2 white--text py-2">
            seleccione el rango de fechas para realizar la busqueda:
          </p>
          <v-row no-gutters>
            <v-col cols="6">
              <v-text-field
                v-model="xfecha"
                label="Fecha inicial:"
                type="date"
                class="pr-2"
                dense
                hide-details
                outlined />
            </v-col>
            <v-col cols="6">
              <v-text-field v-model="xfecha2" label="Fecha final:" type="date" dense hide-details outlined />
            </v-col>
          </v-row>

          <p class="my-0 text-center red--text">{{ msg }}</p>
          <v-progress-linear indeterminate v-if="loading" />

          <div class="text-center" v-show="false">
            <download-excel
              class="btn btn-primary mt-4 btnexcel"
              :data="json_data"
              :fields="json_fields"
              ref="btnexcel"
              worksheet="AnitaLavaLaTina"
              name="recaudacion-recibos.xls">
              Descargar Excel
            </download-excel>
          </div>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="success" :disabled="loading" outlined @click="descargarExcel()">
            <v-icon small left> mdi-download </v-icon>
            Descargar Excel
          </v-btn>
          <v-btn color="red" :disabled="loading" outlined @click="dialog = false">
            <v-icon small left> mdi-close </v-icon>
            Cerrar
          </v-btn>
          <div></div>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import xaxios from '@/xaxios';
  import DownloadExcel from 'vue-json-excel';
  export default {
    data(vue) {
      return {
        dialog: false,
        loading: false,
        xfecha: null,
        xfecha2: null,
        msg: '',

        json_meta: [
          [
            {
              key: 'charset',
              value: 'utf-8',
            },
          ],
        ],
        json_fields: {
          Agrupador: 'agrupador',
          area: 'area',
          categoria: 'categoria',
          codigo: 'codigo',
          concepto_pago: 'concepto_pago',
          nro_factura: 'nro_factura',
          fecha_fin: 'fecha_fin',
          fecha_pago: 'fecha_pago',
          fecha_vencimiento: 'fecha_vencimiento',
          mes: 'mes',
          monto: {
            field: 'monto',
            callback: (value) => {
              return `${vue.redondear(value)}`;
            },
          },
          // monto: 'monto',
          // monto_marketing: 'monto_marketing',
          monto_marketing: {
            field: 'monto_marketing',
            callback: (value) => {
              return vue.redondear(value);
            },
          },
          nombre_compuesto: 'nombre_compuesto',
          nro_cuota: 'nro_cuota',
          nro_recibo: 'nro_recibo',
          observacion_pago: 'observacion_pago',
          sede: 'sede',
          unidad_negocio: 'unidad_negocio',
          universidad: 'universidad',
        },
        json_data: [],
      };
    },
    components: { DownloadExcel },
    methods: {
      openmodal() {
        this.dialog = true;
        this.loading = false;
        this.json_data = [];
        this.xfecha = null;
        this.xfecha2 = null;
        this.msg = '';
      },
      parsecomas(str) {
        if (str == null) return '';
        try {
          if (!str) str = 0;
          let number = window.accounting.formatMoney(str, '', 2, '.', ',');
          return number;
        } catch (e) {
          window.console.error(e);
          return str;
        }
      },
      redondear(str) {
        if (str == null) return '';
        try {
          if (!str) str = 0;
          return parseFloat(str).toFixed(2);
        } catch (e) {
          window.console.error(e);
          return str;
        }
      },
      async descargarExcel() {
        this.msg = '';
        if (!this.xfecha2) this.msg = 'Seleccione fecha final';
        if (!this.xfecha) this.msg = 'Seleccione fecha inicial';
        if (this.msg) return;
        this.loading = true;
        this.json_data = [];

        let url = `${process.env.VUE_APP_API_REST}/api/v1/recaudacion/reporte_recibos?fecha_inicio=${this.xfecha}&fecha_fin=${this.xfecha2}`;
        let res = await xaxios
          .get(url)
          .then((result) => result)
          .catch((error) => error);
        if (res.data) {
          window.console.log('res..', res.data.data);
          this.json_data = res.data.data;
          this.msg = '';
          let vue = this;
          setTimeout(() => {
            vue.$refs.btnexcel.generate();
            vue.loading = false;
          }, 700);
        } else {
          window.console.log('res err..', res);
          this.msg = res;
          this.loading = false;
        }
      },
    },
  };
</script>
